"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNumTicks = exports.defaultTickPadding = exports.defaultTickSize = exports.chartMargins = exports.cardWidthRegular = exports.cardWidthWide = exports.heightTall = exports.heightRegular = exports.widthNarrow = exports.widthVeryWide = exports.widthWide = exports.widthRegular = exports.varCorrelationTableCellHeight = exports.chartFontSize = void 0;
exports.chartFontSize = 9; // In pixels, should match value in styles file
exports.varCorrelationTableCellHeight = 19; // 3px more than height in main style file
exports.widthRegular = 350;
exports.widthWide = 400;
exports.widthVeryWide = 600; // Line chart + scatter
exports.widthNarrow = 250; // used for VariableCorrelationTable
exports.heightRegular = 200;
exports.heightTall = 400; // line chart and scatter
exports.cardWidthWide = 450;
exports.cardWidthRegular = 400;
exports.chartMargins = {
    top: 20,
    bottom: 40,
    left: 45,
    right: 20,
};
exports.defaultTickSize = 0;
exports.defaultTickPadding = 7;
exports.defaultNumTicks = 10;
//# sourceMappingURL=sizes.js.map